import { useRef, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { grabarContacto } from '../../service/AffariService';

const ContactoAgregarDialog = ({ visible, onHide, data, fetchContactos }) => {
    const [nombre, setNombre] = useState('');
    const [correo, setCorreo] = useState('');
    const [telefono, setTelefono] = useState('');
    const [correoValido, setCorreoValido] = useState(true);
    const [telefonoValido, setTelefonoValido] = useState(true);
    const toast = useRef(null);

    const formatChileanPhone = (value) => {
        const cleaned = value.replace(/\D/g, '');
        if (!cleaned) {
            return '';
        }
        if (cleaned.startsWith('56') && cleaned.length > 8) {
            const rest = cleaned.slice(2, 11);
            if (rest.length <= 8) {
                return rest.replace(/(\d{4})(\d{0,4})/, '+56 $1 $2').trim();
            }
            return rest.replace(/(\d{1})(\d{4})(\d{0,4})/, '+56 $1 $2 $3').trim();
        }
        if (cleaned.length <= 8) {
            return cleaned.replace(/(\d{4})(\d{0,4})/, '$1 $2').trim();
        }
        return cleaned.slice(0, 9).replace(/(\d{1})(\d{4})(\d{0,4})/, '$1 $2 $3').trim();
    };

    const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    const validatePhone = (value) => {
        const digits = value.replace(/\D/g, '');
        return digits.length >= 8 && digits.length <= 11;
    };

    const handleTelefonoChange = (e) => {
        const formatted = formatChileanPhone(e.target.value);
        setTelefono(formatted);
        setTelefonoValido(!formatted || validatePhone(formatted));
    };

    const handleGuardar = async () => {
        const correoOk = validateEmail(correo.trim());
        const telefonoOk = validatePhone(telefono);
        setCorreoValido(correoOk);
        setTelefonoValido(telefonoOk);

        if (!nombre.trim()) {
            toast.current?.show({ severity: 'warn', summary: 'Validación', detail: 'Ingresa un nombre.', life: 3000 });
            return;
        }

        if (!correoOk) {
            toast.current?.show({ severity: 'warn', summary: 'Validación', detail: 'Ingresa un correo válido.', life: 3000 });
            return;
        }

        if (!telefonoOk) {
            toast.current?.show({ severity: 'warn', summary: 'Validación', detail: 'Ingresa un teléfono válido.', life: 3000 });
            return;
        }

        try {
            await grabarContacto(data?.cliente?.codigo, correo.trim(), 0, nombre, telefono);
            await fetchContactos?.();
            toast.current?.show({ severity: 'success', summary: 'Contacto', detail: 'Contacto guardado.', life: 3000 });
            onHide();
            setNombre('');
            setCorreo('');
            setTelefono('');
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Contacto', detail: 'No se pudo guardar el contacto.', life: 3000 });
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <Dialog 
                header="Contacto" 
                visible={visible} 
                className="p-fluid custom-dialog"
                onHide={() => {
                    setNombre('');
                    setCorreo('');
                    setTelefono('');
                    setCorreoValido(true);
                    setTelefonoValido(true);
                    onHide();
                }}
                footer={
                    <div className="flex justify-content-end">
                        <Button label="Guardar" icon="pi pi-check" onClick={handleGuardar} />
                    </div>
                }
            >
                
                <div className="p-fluid">
                    <div className="field mb-3">
                        <label htmlFor="nombre" className="block mb-2">Nombre</label>
                        <InputText 
                            id="nombre" 
                            value={nombre} 
                            onChange={(e) => setNombre(e.target.value)} 
                            placeholder="Ingrese su nombre"
                            className={!nombre.trim() ? 'p-invalid' : ''}
                        />
                    </div>
                    <div className="field mb-3">
                        <label htmlFor="correo" className="block mb-2">Correo</label>
                        <InputText 
                            id="correo" 
                            value={correo} 
                            onChange={(e) => {
                                const value = e.target.value;
                                setCorreo(value);
                                setCorreoValido(!value || validateEmail(value.trim()));
                            }} 
                            onBlur={() => setCorreoValido(!correo || validateEmail(correo.trim()))}
                            className={!correoValido ? 'p-invalid' : ''}
                            placeholder="ejemplo@correo.cl"
                        />
                        {!correoValido}
                    </div>
                    <div className="field mb-3">
                        <label htmlFor="telefono" className="block mb-2">Teléfono</label>
                        <InputText 
                            id="telefono" 
                            value={telefono} 
                            onChange={handleTelefonoChange} 
                            onBlur={() => setTelefonoValido(!telefono || validatePhone(telefono))}
                            className={!telefonoValido ? 'p-invalid' : ''}
                            placeholder="9 1234 5678 o 2 1234 5678"
                            maxLength={15}
                        />
                        {!telefonoValido}
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default ContactoAgregarDialog;
